<div class="nav-item" [class.active]="isActive">
  <div class="button-container">
    @if (count && count > 0) {
      <div class="notification-badge fs-body-xs semibold" role="status">
        {{ count > 9 ? '9+' : count }}
      </div>
    }
    @if (hasBadge) {
      <div class="notification-dot" role="status"></div>
    }
    <div class="icon-box">
      <ptl-icon [icon]="icon" [size]="size"></ptl-icon>
    </div>
  </div>
</div>
